<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="User-Management-Menu">
    <mat-icon style="transform: scale(2);">more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before">
    <button mat-menu-item (click)="moveUser()">
        <mat-icon>cached</mat-icon>
        <span>Verschieben</span>
    </button>
    <button mat-menu-item (click)="disableUser()">
        <mat-icon>remove_circle_outline</mat-icon>
        <span>Sperren</span>
    </button>
</mat-menu>
